
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M9.597 19 13 22.403 9.401 26 6 22.599 9.597 19zm7.811-16c.414 0 .812.165 1.104.457l11.032 11.03a1.56 1.56 0 0 1 0 2.205c-1.092 1.101-2.92 2.918-4.966 4.965a9.021 9.021 0 0 1-12.686-.55 9.017 9.017 0 0 1-.551-12.679l4.963-4.971c.292-.292.69-.457 1.104-.457zm1.86 10.734a2.5 2.5 0 1 0-3.536 3.534 2.5 2.5 0 0 0 3.536-3.534zM27 12l4-4M1 31l6-6M21 5l4-4","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    